import * as detail from '../detail';
import * as utils from '../utils';
const {ErrorApi, JsonFetch} = utils;
import MarbesAuthApi from "./../api/gen/reactcore/MarbesAuthApi";
import {storeFromArea} from "./../utils";

export const AUTH_INFO_AREA = "authInfo";
export const AUTH_LOGIN = "authLogin";
export const AUTH_LOGOUT = "authLogout";

const ID = "";

/**
 * Načtení informace o přihlášení.
 * @return {function(*, *)}
 */
export function fetchAuthInfoIfNeeded() {
    return (dispatch, getState) => {
        const store = storeFromArea(getState(), AUTH_INFO_AREA);

        dispatch(detail.DetailActions.fetchIfNeeded(AUTH_INFO_AREA, ID, (id) => {
            return MarbesAuthApi.check()
                .then(authStatus => {
                    setTimeout(() => {
                        // Pokud načetl nová data, bereme jako nové přihlášení - pokud je jiný login než ten, co byl ve store
                        if (authStatus.auth && (!store.data || authStatus.login !== store.data.login)) {
                            dispatch(loginSucccess(authStatus));
                        }
                    }, 100);

                    return authStatus;
                });
        }));
    }
}

/**
 * Odhlášení uživatele.
 * @return {function()}
 */
export function logout() {
    return (dispatch, getState) => {
        return MarbesAuthApi.logout()
            .then(() => {
                const store = storeFromArea(getState(), AUTH_INFO_AREA);

                dispatch({
                    area: AUTH_INFO_AREA,
                    type: AUTH_LOGOUT,
                    authInfo: store
                });
                dispatch(detail.DetailActions.reset(AUTH_INFO_AREA))
            });
    }
}

/**
 * Informace o úspěšném přihlášení.
 * @param authStatus objekt přihlášení
 * @return {function()}
 */
export function loginSucccess(authStatus) {
    return (dispatch, getState) => {
        const store = storeFromArea(getState(), AUTH_INFO_AREA);
        dispatch({
            area: AUTH_INFO_AREA,
            type: AUTH_LOGIN,
            prevAuthInfo: store,
            nextAuthInfo: {data: authStatus}
        });
        dispatch(detail.DetailActions.setData(AUTH_INFO_AREA, ID, authStatus));
    }
}

/**
 * Zneplatnění informací o přihlášení.
 * @return {function(*, *)}
 */
export function invalidate(id) {
    return (dispatch, getState) => {
        dispatch(detail.DetailActions.invalidate(AUTH_INFO_AREA, ID));
    }
}

export function check() {
    return () => {
        ErrorApi.responseResolver(JsonFetch.get("/api/auth/check")).then((data) => {
            console.info(data);
        });
    }
}

export function login(username, password) {
    return () => {
        ErrorApi.responseResolver(JsonFetch.post("/api/auth/login", null, {username, password}))
    }
}
